module.exports = __webpack_public_path__ + "img/attachment.44ac5f9a.svg";